// extracted by mini-css-extract-plugin
export default {"container":"ConnectWalletOrPlay_container__dtbjG","fadeIn":"ConnectWalletOrPlay_fadeIn__ZRwOq","image":"ConnectWalletOrPlay_image__FLNfn"};